import { createBrowserRouter, Navigate } from 'react-router-dom'
import Root, { NotFound, RouteError } from './layouts/Root'
import PublicLayout from './layouts/PublicLayout'
import AppLayout from './layouts/AppLayout'
import RequireAuth from './layouts/RequireAuth'
import Home from './pages/public/Home'
import Pricing from './pages/public/Pricing'
import Agencies from './pages/public/Agencies'
import HowItWorks from './pages/public/HowItWorks'
import Terms from './pages/public/Terms'
import Privacy from './pages/public/Privacy'
import DataDeletion from './pages/public/DataDeletion'
import Login from './pages/auth/Login'
import Signup from './pages/auth/Signup'
import CreateAccount from './pages/auth/CreateAccount'
import ForgotPassword from './pages/auth/ForgotPassword'
import ResetPassword from './pages/auth/ResetPassword'
import VerifyEmail from './pages/auth/VerifyEmail'
import ConfirmEmailChange from './pages/auth/ConfirmEmailChange'
import AcceptInvite from './pages/auth/AcceptInvite'
import TwoFactor from './pages/auth/TwoFactor'
import Logout from './pages/auth/Logout'
import ConnectLink from './pages/connect/ConnectLink'
import SharedReport from './pages/shared/SharedReport'
import AppHome from './pages/app/AppHome'
import Onboarding from './pages/app/Onboarding'
import Profile from './pages/app/Profile'
import Dashboard from './pages/company/Dashboard'
import Suggestions from './pages/company/Suggestions'
import Ideas from './pages/company/Ideas'
import Campaigns from './pages/company/Campaigns'
import CampaignDetail from './pages/company/CampaignDetail'
import NewCampaign from './pages/company/NewCampaign'
import Results from './pages/company/Results'
import Sales from './pages/company/Sales'
import Autopilot from './pages/company/Autopilot'
import History from './pages/company/History'
import TrackingOverview from './pages/company/tracking/TrackingOverview'
import TrackingSite from './pages/company/tracking/TrackingSite'
import TrackingEvents from './pages/company/tracking/TrackingEvents'
import LandingPages from './pages/company/tracking/LandingPages'
import LandingEditor from './pages/company/tracking/LandingEditor'
import AnalyticsPage from './pages/company/tracking/AnalyticsPage'
import Connections from './pages/company/Connections'
import PaymentGuide from './pages/company/PaymentGuide'
import SettingsBusiness from './pages/company/SettingsBusiness'
import SettingsTeam from './pages/company/SettingsTeam'
import SettingsAiProfile from './pages/company/SettingsAiProfile'
import SettingsNotifications from './pages/company/SettingsNotifications'
import Companies from './pages/account/Companies'
import Users from './pages/account/Users'
import Plan from './pages/account/Plan'
import Branding from './pages/account/Branding'
import AgencyOverview from './pages/agency/Overview'
import Notifications from './pages/notifications/Notifications'
import AdminHome from './pages/admin/AdminHome'
import AdminAccounts from './pages/admin/AdminAccounts'
import AdminAccount from './pages/admin/AdminAccount'
import AdminQueues from './pages/admin/AdminQueues'
import AdminFlags from './pages/admin/AdminFlags'
import AdminAi from './pages/admin/AdminAi'
import AdminSiteLeads from './pages/admin/AdminSiteLeads'

// `handle.title` vira o título da aba (ver layouts/Root.tsx)
export const router = createBrowserRouter([
  {
    element: <Root />,
    errorElement: <RouteError />,
    children: [
      {
        element: <PublicLayout />,
        children: [
          { path: '/', element: <Home /> },
          { path: '/precos', handle: { title: 'Preços' }, element: <Pricing /> },
          { path: '/agencias', handle: { title: 'Para agências' }, element: <Agencies /> },
          { path: '/como-funciona', handle: { title: 'Como funciona' }, element: <HowItWorks /> },
          { path: '/termos', handle: { title: 'Termos de uso' }, element: <Terms /> },
          { path: '/privacidade', handle: { title: 'Política de privacidade' }, element: <Privacy /> },
          { path: '/exclusao-de-dados', handle: { title: 'Exclusão de dados' }, element: <DataDeletion /> },
        ],
      },
      { path: '/login', handle: { title: 'Entrar' }, element: <Login /> },
      { path: '/cadastro', handle: { title: 'Criar conta' }, element: <Signup /> },
      { path: '/recuperar-senha', handle: { title: 'Recuperar senha' }, element: <ForgotPassword /> },
      { path: '/redefinir-senha/:token', handle: { title: 'Nova senha' }, element: <ResetPassword /> },
      { path: '/verificar-email/:token', handle: { title: 'Confirmar e-mail' }, element: <VerifyEmail /> },
      { path: '/confirmar-troca-de-email/:token', handle: { title: 'Trocar e-mail' }, element: <ConfirmEmailChange /> },
      { path: '/convite/:token', handle: { title: 'Convite' }, element: <AcceptInvite /> },
      { path: '/2fa', handle: { title: 'Verificação em duas etapas' }, element: <TwoFactor /> },
      { path: '/sair', handle: { title: 'Saindo' }, element: <Logout /> },
      { path: '/conectar/:token', handle: { title: 'Conectar contas' }, element: <ConnectLink /> },
      { path: '/r/:token', handle: { title: 'Relatório' }, element: <SharedReport /> },
      {
        element: <RequireAuth />,
        children: [
          { path: '/criar-conta', handle: { title: 'Crie sua conta' }, element: <CreateAccount /> },
          {
            path: '/app',
            handle: { title: 'Painel' },
            element: <AppLayout />,
            children: [
              { index: true, element: <AppHome /> },
              { path: 'perfil', handle: { title: 'Meu perfil' }, element: <Profile /> },
              { path: 'agencia', handle: { title: 'Visão dos clientes' }, element: <AgencyOverview /> },
              { path: 'notificacoes', handle: { title: 'Avisos' }, element: <Notifications /> },
              { path: 'conta/:accountId/empresas', handle: { title: 'Empresas' }, element: <Companies /> },
              { path: 'conta/:accountId/usuarios', handle: { title: 'Usuários' }, element: <Users /> },
              { path: 'conta/:accountId/plano', handle: { title: 'Plano e cobrança' }, element: <Plan /> },
              { path: 'conta/:accountId/marca', handle: { title: 'Marca da agência' }, element: <Branding /> },
              {
                path: ':companyId',
                children: [
                  { index: true, element: <Navigate to="inicio" replace /> },
                  { path: 'onboarding', handle: { title: 'Primeiros passos' }, element: <Onboarding /> },
                  { path: 'inicio', handle: { title: 'Início' }, element: <Dashboard /> },
                  { path: 'sugestoes', handle: { title: 'Sugestões' }, element: <Suggestions /> },
                  { path: 'ideias', handle: { title: 'Ideias da semana' }, element: <Ideas /> },
                  { path: 'campanhas', handle: { title: 'Campanhas' }, element: <Campaigns /> },
                  { path: 'campanhas/:campaignId', handle: { title: 'Campanha' }, element: <CampaignDetail /> },
                  { path: 'criar', handle: { title: 'Criar anúncio' }, element: <NewCampaign /> },
                  { path: 'criar/:draftId', handle: { title: 'Criar anúncio' }, element: <NewCampaign /> },
                  { path: 'resultados', handle: { title: 'Resultados' }, element: <Results /> },
                  { path: 'vendas', handle: { title: 'Clientes e vendas' }, element: <Sales /> },
                  { path: 'piloto', handle: { title: 'Piloto automático' }, element: <Autopilot /> },
                  { path: 'historico', handle: { title: 'Histórico' }, element: <History /> },
                  { path: 'trackeamento', handle: { title: 'Medição' }, element: <TrackingOverview /> },
                  { path: 'trackeamento/meu-site', handle: { title: 'Meu site' }, element: <TrackingSite /> },
                  { path: 'trackeamento/eventos', handle: { title: 'Eventos e conversões' }, element: <TrackingEvents /> },
                  { path: 'trackeamento/analytics', handle: { title: 'Visitas do site' }, element: <AnalyticsPage /> },
                  { path: 'trackeamento/landing-pages', handle: { title: 'Páginas' }, element: <LandingPages /> },
                  { path: 'trackeamento/landing-pages/:pageId', handle: { title: 'Editar página' }, element: <LandingEditor /> },
                  { path: 'contas', handle: { title: 'Contas conectadas' }, element: <Connections /> },
                  { path: 'contas/pagamento', handle: { title: 'Como pagar os anúncios' }, element: <PaymentGuide /> },
                  { path: 'config/negocio', handle: { title: 'Configurações' }, element: <SettingsBusiness /> },
                  { path: 'config/equipe', handle: { title: 'Equipe' }, element: <SettingsTeam /> },
                  { path: 'config/perfil-ia', handle: { title: 'Perfil para a IA' }, element: <SettingsAiProfile /> },
                  { path: 'config/avisos', handle: { title: 'Meus avisos' }, element: <SettingsNotifications /> },
                ],
              },
            ],
          },
        ],
      },
      {
        element: <RequireAuth staff />,
        children: [
          {
            path: '/admin',
            handle: { title: 'Backoffice' },
            element: <AppLayout />,
            children: [
              { index: true, element: <AdminHome /> },
              { path: 'contas', handle: { title: 'Contas (backoffice)' }, element: <AdminAccounts /> },
              { path: 'contas/:accountId', handle: { title: 'Conta (backoffice)' }, element: <AdminAccount /> },
              { path: 'filas', handle: { title: 'Filas' }, element: <AdminQueues /> },
              { path: 'flags', handle: { title: 'Recursos' }, element: <AdminFlags /> },
              { path: 'ia', handle: { title: 'IA' }, element: <AdminAi /> },
              { path: 'contatos', handle: { title: 'Contatos do site' }, element: <AdminSiteLeads /> },
            ],
          },
        ],
      },
      { path: '*', handle: { title: 'Página não encontrada' }, element: <NotFound /> },
    ],
  },
])
